
import Input, { type DateProps, type InputProps, type SelectEnumProps, type SelectProps } from "ui/base/Input";
import { useFieldContext } from "../fabric";


type Props = InputProps & {
	label: string;
	flex?: string;
};

Field.Date = ({ required, ...props }: DateProps) => {
	const field = useFieldContext<string>();
	const meta = field.state.meta;
	const errors = meta.errors.map(e => e.message as string);

	return (
		<Input.Date
			value={field.state.value ? new Date(field.state.value) : null}
			onChange={(v) => field.handleChange(v?.toISOString() || "")}
			errors={errors}
			{...props}
		/>
	);
};

Field.Select = (props: SelectProps) => {
	const field = useFieldContext<string>();
	const meta = field.state.meta;
	const errors = meta.errors.map(e => e.message as string);

	return (
		<Input.Select
			{...props}
			value={field.state.value}
			onChange={e => field.handleChange(e.target.value as string)}
			error={!meta.isValid}
			errors={errors}
		/>
	);
};

Field.Enum = <T extends Record<number, string>>(props: SelectEnumProps<T>) => {
	const field = useFieldContext<string>();
	const meta = field.state.meta;
	const errors = meta.errors.map(e => e.message as string);

	return (
		<Input.SelectEnum
			{...props}
			value={field.state.value}
			onChange={e => field.handleChange(e.target.value as string)}
			error={!meta.isValid}
			errors={errors}
		/>
	);
};

Field.Image = ({ label, dark }: { label: string, dark?: boolean }) => {
	const field = useFieldContext<File | string>();
	const meta = field.state.meta;
	const errors = meta.errors.map(e => e.message as string);

	return (
		<Input.Image
			label={label}
			value={field.state.value}
			dark={dark}
			onChange={e => field.handleChange(e.target.files?.[0] || "")}
			errors={errors}
		/>
	);
};

export default function Field ({ flex, ...props }: Props) {
	const field = useFieldContext<string>();
	const meta = field.state.meta;
	const errors = meta.errors.map(e => e.message as string);
	const style = {
		root: {
			flex: flex || "1 1 0",
			...props.sx
		}
	} as SxProps;

	return (
		<Input
			{...props}
			value={field.state.value}
			onChange={e => field.handleChange(e.target.value)}
			error={!meta.isValid}
			errors={errors}
			sx={style.root}
		/>
	);
}